import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const SanMarinoFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15891'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15891)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V6.53333H0V14Z'
					fill='#7CCCF5'
				/>
				<path
					d='M8.76237 6.53333C8.76237 6.16514 8.46389 5.86666 8.0957 5.86666C7.72751 5.86666 7.42904 6.16514 7.42904 6.53333H8.76237ZM8.71636 8.72855C9.03643 8.91055 9.44343 8.79863 9.62543 8.47856C9.80743 8.1585 9.6955 7.7515 9.37544 7.5695L8.71636 8.72855ZM10.6713 7.54214C10.3593 7.73768 10.2649 8.1491 10.4605 8.46107C10.656 8.77305 11.0674 8.86744 11.3794 8.6719L10.6713 7.54214ZM12.5719 6.53333C12.5719 6.16514 12.2734 5.86666 11.9052 5.86666C11.537 5.86666 11.2386 6.16514 11.2386 6.53333H12.5719ZM7.42904 6.53333C7.42904 7.4773 7.95246 8.29417 8.71636 8.72855L9.37544 7.5695C9.00308 7.35776 8.76237 6.96944 8.76237 6.53333H7.42904ZM11.3794 8.6719C12.0913 8.22572 12.5719 7.43759 12.5719 6.53333H11.2386C11.2386 6.9514 11.0177 7.32505 10.6713 7.54214L11.3794 8.6719Z'
					fill='#445F42'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.99926 7.46663C10.5252 7.46663 10.9516 6.83982 10.9516 6.06663C10.9516 5.29343 10.5252 4.66663 9.99926 4.66663C9.47327 4.66663 9.04688 5.29343 9.04688 6.06663C9.04688 6.83982 9.47327 7.46663 9.99926 7.46663Z'
					fill='#D89F3D'
				/>
			</g>
		</svg>
	);
};

export default SanMarinoFlagIcon;
